import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRole } from "../../store/auth/selectors";

import {
  BRAND_FAVICON,
  BRAND_LOGO_DARK_BG,
  BRAND_LOGO_LIGHT_BG,
} from "../../constants/branding";

const Sidebar = (props) => {
  const role = useSelector(selectRole);

  return (
    <React.Fragment>
      <div className="vertical-menu bg-primary">
        <div className="navbar-brand-box bg-primary">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={BRAND_FAVICON} alt="JobArk" height="22" />
            </span>
            <span className="logo-lg">
              <img src={BRAND_LOGO_LIGHT_BG} alt="JobArk" height="17" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={BRAND_FAVICON} alt="JobArk" height="22" />
            </span>
            <span className="logo-lg">
              <img src={BRAND_LOGO_DARK_BG} alt="JobArk" height="19" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>

        <div className="sidebar-backgroun bg-primary"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout
  };
};
export default connect(mapStatetoProps, {})(withRouter(withTranslation()(Sidebar)));
